import { Link } from "../router";
import "./MusicVideo.css";

/** Standalone full-bleed player for the Paradise video. */
export function MusicVideo() {
  return (
    <div className="page-music-video">
      <Link to="/" id="back-link">
        &larr; Back
      </Link>

      <div id="video-wrap">
        <iframe
          src="https://www.youtube-nocookie.com/embed/aUzzjOuue4A?autoplay=1"
          title="Paradise - Music Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}
